export default "__VITE_ASSET__CC3SBja6__"